var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{staticClass:"video-banner video-banner-mobile",attrs:{"autoplay":"autoplay","playsinline":"","loop":"loop","muted":"muted"},domProps:{"muted":true}},[_vm._t("source")],2)}
var staticRenderFns = []

export { render, staticRenderFns }